import React, {useState} from 'react';
import {FormattedMessage, useIntl} from "react-intl";
import {Table, TableBody, TableCell, TableHead, TableRow} from "@mui/material";
import {PersonDto} from "../../../../modules/exos/dto/PersonDto";
import dayjs from "dayjs";
import {Formats} from "../../../../constants/Formats";

export type SearchResultProps = {
    searchResult: Array<PersonDto>;
};

const SearchResult: React.FC<SearchResultProps> = (props) => {
    const intl = useIntl();

    return (
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>{intl.formatMessage({id: 'EXOS_STAFF_NO'})}</TableCell>
                        <TableCell>{intl.formatMessage({id: "EXOS_STAFF_FULL_NAME"})}</TableCell>
                        <TableCell>{intl.formatMessage({id: "EXOS_STAFF_BADGE_NO"})}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.searchResult.map((row, index) => {
                        let rowStyle= {};
                        if(row.blocked||!row.accessRightEffective){
                            rowStyle= {backgroundColor:"#cf4343"};
                        }
                        return (
                            <TableRow key={row.personId} style={rowStyle}>
                                <TableCell>{row.staffNo}</TableCell>
                                <TableCell>{row.fullName}</TableCell>
                                <TableCell>{row.badgeNo}</TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
    );
};

export default SearchResult;